import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=852ec81e&scoped=true&"
import script from "./newsdetails.vue?vue&type=script&lang=js&"
export * from "./newsdetails.vue?vue&type=script&lang=js&"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=852ec81e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ec81e",
  null
  
)

export default component.exports